module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("i9511"))).then(() => parcelRequire('2KbAe'));